// extracted by mini-css-extract-plugin
module.exports = {"smallUrgencyTimer":"smallShippingUrgencyTimer_smallUrgencyTimer__b__bJ","styledTimerNumber":"smallShippingUrgencyTimer_styledTimerNumber__LkVpX"};